import React from "react";
import FavoriteIcon from "@mui/icons-material/Favorite";
const Footer = () => {
  return (
    <div className="d-flex justify-content-between p-4">
      {/* <p>© Copyright 2023 ABB</p>
      <p className="fw-700">
        SF V1.0 - Powered by RevaaloLabs
        <FavoriteIcon className="ms-2 text-danger" />{" "}
      </p> */}
    </div>
  );
};

export default Footer;
